import React, { useEffect, useState } from "react";
import firebase from "../services/FirebaseService";
import { Redirect } from "react-router-dom";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/support.css";
import { AuthProvider, IfFirebaseAuthed, IfFirebaseUnAuthed } from "../context/FirebaseAuthContext";
import SupportService from "../services/SupportService";

const Intro = () => {
	
	const supportService = new SupportService();

	const [ success, setSuccess ] = useState(false);

	const createChat = async (e) => {
		e.preventDefault();

		try {

			await supportService.createChat(firebase.auth().currentUser.uid);

			setSuccess(true);
		}
		catch(error) {
			console.error(error);
		}

	};

	return (
		<section id="support-section">
			<h1>Support Chat</h1>
			<p>Get support from professional mentors.</p>
			<button onClick={e => createChat(e)}>Start a Chat</button>
			{ success && <Redirect to="/support/chat" /> }
		</section>
	);
};

const SupportPage = ({ match }) => {

	const supportService = new SupportService();

	const [ activeChat, setActiveChat ] = useState(false);
	const [ pending, setPending ] = useState(true);

	useEffect(() => {
		
		firebase.auth().onAuthStateChanged(async user => {
			if(user) {
				try {
					setActiveChat(await supportService.doesHaveActiveChat(user.uid));

					setPending(false);
				}
				catch(error) {
					console.error(error);
				}
			}
		});
		
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<AuthProvider>
				<IfFirebaseAuthed>
					<Navbar />
					{ !activeChat && !pending && <Intro /> }
					{ activeChat && !pending && <Redirect to="/support/chat" /> }
					<Footer />
				</IfFirebaseAuthed>
				<IfFirebaseUnAuthed>
					<Redirect to="/auth/login" />
				</IfFirebaseUnAuthed>
			</AuthProvider>
		</>
	)
};

export default SupportPage;